"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9221],{

/***/ 11422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ Avatar; },
  "z": function() { return /* binding */ avatar_Verified; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-avatar/dist/index.module.js
var index_module = __webpack_require__(16235);
// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/avatar/styles.ts


var Container = (0,stitches/* styled */.zo)("div", {
    position: "relative",
    display: "flex"
});
var StyledRoot = (0,stitches/* styled */.zo)(index_module/* Root */.fC, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    overflow: "hidden",
    userSelect: "none",
    width: 128,
    height: 128,
    backgroundColor: "$secondaryBackground",
    variants: {
        round: {
            true: {
                borderRadius: 9999
            }
        }
    }
});
var StyledImage = (0,stitches/* styled */.zo)(index_module/* Image */.Ee, {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit"
});
var StyledFallback = (0,stitches/* styled */.zo)(index_module/* Fallback */.NY, {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var Verified = (0,stitches/* styled */.zo)("div", {
    margin: "0 $space$5",
    fontSize: 14
});
var Path = (0,stitches/* styled */.zo)("path", {});

;// CONCATENATED MODULE: ./src/components/avatar/index.tsx



var Avatar = function(param) {
    var username = param.username, path = param.path, _round = param.round, round = _round === void 0 ? true : _round, size = param.size;
    if (size) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
                round: round,
                css: {
                    width: size,
                    height: size
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: path,
                        alt: "".concat(username, " profile")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                        delayMs: path ? 600 : 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                            hash: username
                        })
                    })
                ]
            })
        });
    }
    // adjusts to 100% parent
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        css: {
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRoot, {
            round: round,
            css: {
                width: "100%",
                height: "100%",
                position: "relative",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                backgroundRepeat: "no-repeat",
                "&:after": {
                    content: "",
                    display: "block",
                    paddingTop: "calc(1 * 100%);"
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                    src: path,
                    alt: "".concat(username, " profile"),
                    css: {
                        position: "absolute",
                        width: "100%"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFallback, {
                    delayMs: path ? 600 : 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Identicon */.bK, {
                        hash: username
                    })
                })
            ]
        })
    });
};
var avatar_Verified = function(param) {
    var _size = param.size, size = _size === void 0 ? 14 : _size, _secondary = param.secondary, secondary = _secondary === void 0 ? false : _secondary;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: size,
            height: size,
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    d: "M4.78117 0.743103C5.29164 -0.247701 6.70826 -0.247701 7.21872 0.743103C7.52545 1.33846 8.21742 1.62509 8.8553 1.42099C9.91685 1.08134 10.9186 2.08304 10.5789 3.1446C10.3748 3.78247 10.6614 4.47445 11.2568 4.78117C12.2476 5.29164 12.2476 6.70826 11.2568 7.21872C10.6614 7.52545 10.3748 8.21742 10.5789 8.8553C10.9186 9.91685 9.91685 10.9186 8.8553 10.5789C8.21742 10.3748 7.52545 10.6614 7.21872 11.2568C6.70826 12.2476 5.29164 12.2476 4.78117 11.2568C4.47445 10.6614 3.78247 10.3748 3.1446 10.5789C2.08304 10.9186 1.08134 9.91685 1.42099 8.8553C1.62509 8.21742 1.33846 7.52545 0.743103 7.21872C-0.247701 6.70826 -0.247701 5.29164 0.743103 4.78117C1.33846 4.47445 1.62509 3.78247 1.42099 3.1446C1.08134 2.08304 2.08304 1.08134 3.1446 1.42099C3.78247 1.62509 4.47445 1.33846 4.78117 0.743103Z",
                    css: {
                        fill: secondary ? "$secondaryFill" : "$primaryFill"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Path, {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.43961 4.23998C8.64623 4.43922 8.65221 4.76823 8.45297 4.97484L5.40604 8.13462L3.54703 6.20676C3.34779 6.00014 3.35377 5.67113 3.56039 5.47189C3.76701 5.27266 4.09602 5.27864 4.29526 5.48525L5.40604 6.63718L7.70475 4.25334C7.90398 4.04672 8.23299 4.04074 8.43961 4.23998Z",
                    css: {
                        fill: "$primaryBackground"
                    }
                })
            ]
        })
    });
// return (
//   <svg width={size} height={size} viewBox="0 0 18 18">
//     <g fill="none" fillRule="evenodd">
//       <path fill="#38D" fillRule="nonzero" d="M9 18A9 9 0 108.999-.001 9 9 0 009 18z" />
//       <path stroke="#FFF" strokeWidth="2" d="M4.13 8.767l3.086 3.087 6.656-6.656" />
//     </g>
//   </svg>
// );
};


/***/ }),

/***/ 39221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Header": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/use-intl/dist/use-intl.esm3.js + 18 modules
var use_intl_esm3 = __webpack_require__(72439);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(41248);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/components/avatar/index.tsx + 1 modules
var avatar = __webpack_require__(11422);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js + 1 modules
var index_module = __webpack_require__(84113);
// EXTERNAL MODULE: ./src/state/global/index.ts
var global = __webpack_require__(64275);
// EXTERNAL MODULE: ./src/utils/ipfs.ts
var ipfs = __webpack_require__(80125);
// EXTERNAL MODULE: ./src/utils/time-ago.ts
var time_ago = __webpack_require__(88080);
// EXTERNAL MODULE: ./src/utils/user.ts
var utils_user = __webpack_require__(12857);
// EXTERNAL MODULE: ./node_modules/@versumstudios/ui/dist/index.es.js + 8 modules
var index_es = __webpack_require__(33498);
;// CONCATENATED MODULE: ./src/components/notifications/collaboration.tsx











var CollaborationNotification = function(param) {
    var notificationid = param.notificationid, timestamp = param.timestamp, viewed = param.viewed, user = param.user, platform = param.platform, id = param.id;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var markHasRead = function() {
        dispatch({
            type: global/* actions.GLOBAL_USER_VIEWS_NOTIFICATION */.Nw.GLOBAL_USER_VIEWS_NOTIFICATION,
            payload: notificationid
        });
    };
    var screenName = (0,utils_user/* getScreenName */.GG)(user.verified_on_chain, user.screen_name, user.id, user.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/token/".concat(platform, "/").concat(id),
        locale: router.locale,
        prefetch: false,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            style: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
                asChild: true,
                onClick: markHasRead,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                    css: {
                        width: "100%",
                        padding: 12,
                        cursor: "pointer",
                        "&:hover": {
                            backgroundColor: "$secondaryBackground"
                        },
                        "&:focus": {
                            outline: "none"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            css: {
                                marginRight: "$space$4"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
                                username: user.id,
                                path: (0,ipfs/* getURLFromIPFSorHTTP */.Fk)(user.profile_image_uri),
                                size: 40
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                flexGrow: 1,
                                flexDirection: "column",
                                justifyContent: "space-between"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Text */.xv, {
                                        unset: true,
                                        css: {
                                            fontSize: 14,
                                            color: "$secondaryFill"
                                        },
                                        children: [
                                            screenName,
                                            " invited you to collaborate."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            css: {
                                                color: "$secondaryFill",
                                                fontSize: 14
                                            },
                                            children: time_ago/* timeAgo.format */.S.format(timestamp)
                                        }),
                                         false && /*#__PURE__*/ 0
                                    ]
                                })
                            ]
                        }),
                        !viewed && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            vertical: true,
                            horizontal: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                css: {
                                    width: 8,
                                    height: 8,
                                    backgroundColor: "$primaryHighlight",
                                    borderRadius: 9999
                                }
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/notifications/insession.tsx






var InSessionNotification = function(param) {
    var notificationid = param.notificationid, timestamp = param.timestamp, viewed = param.viewed, type = param.type, success = param.success, hash = param.hash;
    var dispatch = (0,es/* useDispatch */.I0)();
    var markHasRead = function() {
        dispatch({
            type: global/* actions.GLOBAL_USER_VIEWS_NOTIFICATION */.Nw.GLOBAL_USER_VIEWS_NOTIFICATION,
            payload: notificationid
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
        as: "a",
        variant: "basic",
        href: "https://tzstats.com/".concat(hash),
        target: "_blank",
        rel: "noopener noreferrer",
        css: {
            borderRadius: 0,
            border: "none",
            width: "100%"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
            asChild: true,
            onClick: markHasRead,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                css: {
                    width: "100%",
                    padding: 12,
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "$secondaryBackground"
                    },
                    "&:focus": {
                        outline: "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            marginRight: "$space$4",
                            width: 40,
                            height: 40
                        },
                        vertical: true,
                        horizontal: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Step */.h8, {
                            success: success,
                            error: !success
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                        css: {
                            flexGrow: 1,
                            flexDirection: "column",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    unset: true,
                                    css: {
                                        fontSize: 14,
                                        color: "$secondaryFill"
                                    },
                                    children: success ? "Your ".concat(type, " was successful.") : "Your ".concat(type, " failed")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                    unset: true,
                                    css: {
                                        color: "$secondaryFill",
                                        fontSize: 14
                                    },
                                    children: time_ago/* timeAgo.format */.S.format(timestamp)
                                })
                            })
                        ]
                    }),
                    !viewed && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        vertical: true,
                        horizontal: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                            css: {
                                width: 8,
                                height: 8,
                                backgroundColor: "$primaryHighlight",
                                borderRadius: 9999
                            }
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/notifications/index.ts



// EXTERNAL MODULE: ./src/styles/stitches.ts
var stitches = __webpack_require__(42441);
;// CONCATENATED MODULE: ./src/components/dropdown/notifications-menu/styles.ts

var Trigger = (0,stitches/* styled */.zo)("div", {
    cursor: "pointer",
    width: 24,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    i: {
        fontSize: 18,
        color: "$secondaryFill"
    },
    "&:hover": {
        i: {
            color: "$primaryFill"
        }
    },
    "&:focus": {
        outline: "none",
        i: {
            color: "$primaryFill"
        }
    },
    variants: {
        hasNotification: {
            true: {
                position: "relative",
                "&:after": {
                    position: "absolute",
                    top: 0,
                    right: 0,
                    content: "",
                    width: 8,
                    height: 8,
                    backgroundColor: "$primaryHighlight",
                    borderRadius: 9999
                }
            }
        }
    }
});
var Content = (0,stitches/* styled */.zo)("div", {
    backgroundColor: "$primaryBackground",
    borderRadius: 5,
    overflow: "hidden",
    border: "0.5px solid $colors$primaryBorder",
    boxShadow: "0px 5px 15px -5px hsla(206,22%,7%,.15)"
});
var Scrollable = (0,stitches/* styled */.zo)("div", {
    overflowY: "auto",
    minHeight: 130,
    maxHeight: 325
});
var Item = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    borderBottom: "1px solid $colors$primaryBorder",
    "&:last-child": {
        marginBottom: 0,
        borderBottom: "none"
    },
    "&:focus": {
        outline: "none",
        backgroundColor: "$secondaryBackground"
    }
});

;// CONCATENATED MODULE: ./src/components/dropdown/notifications-menu/index.tsx









var NotificationsMenu = function() {
    var t = (0,use_intl_esm3/* default */.Z)("notifications");
    var notifications = (0,es/* useSelector */.v9)(function(state) {
        return state.global;
    }).notifications;
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleMarkAsRead = function() {
        for(var i = 0; i < notifications.length; i += 1){
            dispatch({
                type: global/* actions.GLOBAL_USER_VIEWS_NOTIFICATION */.Nw.GLOBAL_USER_VIEWS_NOTIFICATION,
                payload: notifications[i].notificationid
            });
        }
    };
    var renderCell = function(props) {
        switch(props.type){
            case "collaboration":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollaborationNotification, (0,_object_spread/* default */.Z)({
                    notificationid: props.notificationid,
                    timestamp: props.timestamp,
                    viewed: props.viewed
                }, props.body));
            case "operationhash":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InSessionNotification, (0,_object_spread/* default */.Z)({
                    notificationid: props.notificationid,
                    timestamp: props.timestamp,
                    viewed: props.viewed
                }, props.body));
            default:
                return null;
        }
    };
    var hasUnread = false;
    for(var i = 0; i < notifications.length; i += 1){
        if (notifications[i].viewed === false) {
            hasUnread = true;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Trigger, {
                    hasNotification: notifications && hasUnread,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        children: "notifications"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Content */.VY, {
                asChild: true,
                sideOffset: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            width: "90vw",
                            flexDirection: "column",
                            "@bp1": {
                                width: 400
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                            css: {
                                flexDirection: "column",
                                "&>*:last-child": {
                                    borderBottom: "unset"
                                }
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Box */.xu, {
                                    css: {
                                        padding: 12,
                                        justifyContent: "space-between"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            css: {
                                                color: "$secondaryFill",
                                                fontSize: 14
                                            },
                                            children: t("title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            variant: "basic",
                                            onClick: handleMarkAsRead,
                                            children: t("read")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Scrollable, {
                                    children: notifications && notifications.length > 0 ? notifications.map(function(notification) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                                            children: renderCell(notification)
                                        }, notification.notificationid);
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        vertical: true,
                                        horizontal: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Text */.xv, {
                                            unset: true,
                                            css: {
                                                color: "$secondaryFill",
                                                fontSize: 14,
                                                padding: "$space$4"
                                            },
                                            children: t("no-notifications")
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/lib/beacon.ts + 211 modules
var beacon = __webpack_require__(91435);
// EXTERNAL MODULE: ./src/state/auth/index.ts
var state_auth = __webpack_require__(30541);
// EXTERNAL MODULE: ./src/utils/node.ts
var node = __webpack_require__(49503);
;// CONCATENATED MODULE: ./src/components/dropdown/user-menu/styles.ts

var styles_Trigger = (0,stitches/* styled */.zo)("div", {
    backgroundColor: "transparent",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus": {
        outline: "none"
    }
});
var styles_Content = (0,stitches/* styled */.zo)("div", {
    minWidth: 150,
    backgroundColor: "$primaryBackground",
    borderRadius: 5,
    overflow: "hidden",
    border: "1px solid $colors$primaryBorder",
    boxShadow: "0px 5px 15px -5px hsla(206,22%,7%,.15)"
});
var styles_Item = (0,stitches/* styled */.zo)("div", {
    padding: "8px 16px",
    borderRadius: 2,
    cursor: "pointer",
    color: "$secondaryFill",
    fontSize: 16,
    "@bp1": {
        fontSize: 14
    },
    "&:focus": {
        outline: "none",
        backgroundColor: "$secondaryBackground",
        color: "$primaryFill"
    }
});
var Separator = (0,stitches/* styled */.zo)("div", {
    height: "1px",
    backgroundColor: "$colors$primaryBorder"
});

;// CONCATENATED MODULE: ./src/components/dropdown/user-menu/index.tsx














function UserProfile() {
    var user = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    }).user;
    var viewer = user === null || user === void 0 ? void 0 : user.id;
    var path = (0,ipfs/* getURLFromIPFSorHTTP */.Fk)(user === null || user === void 0 ? void 0 : user.profile_image_uri);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* Avatar */.q, {
        username: viewer,
        path: path,
        size: 32
    });
}
function UserMenu() {
    var t = (0,use_intl_esm3/* default */.Z)("header");
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var user = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    }).user;
    var viewer = user === null || user === void 0 ? void 0 : user.id;
    var handleLogout = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,node/* testNodeHealth */.M)();
                    case 2:
                        _ctx.next = 4;
                        return (0,beacon/* logout */.kS)();
                    case 4:
                        dispatch({
                            type: state_auth/* actions.AUTH_LOGOUT */.Nw.AUTH_LOGOUT
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Trigger, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfile, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Content */.VY, {
                asChild: true,
                sideOffset: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/user/".concat(viewer, "/created"),
                            locale: router.locale,
                            prefetch: false,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Item, {
                                        children: t("profile")
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/dashboard",
                            locale: router.locale,
                            prefetch: false,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Item, {
                                        children: t("dashboard")
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/settings",
                            locale: router.locale,
                            prefetch: false,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
                                    asChild: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Item, {
                                        children: t("settings")
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Separator */.Z0, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Separator, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Item */.ck, {
                            asChild: true,
                            onSelect: handleLogout,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Item, {
                                children: t("logout")
                            })
                        })
                    ]
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/containers/header/styles.ts



var Container = (0,stitches/* styled */.zo)("header", (0,_define_property/* default */.Z)({
    position: "sticky",
    top: 0,
    width: "100%",
    backgroundColor: "$primaryBackground",
    color: "$primaryFill",
    zIndex: 2
}, "& ".concat(index_es/* Container */.W2), {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
}));
var Auth = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& > *": {
        marginLeft: "$space$3"
    }
});
var Mobile = (0,stitches/* styled */.zo)("div", {
    display: "flex",
    "@bp1": {
        display: "none"
    }
});
var Desktop = (0,stitches/* styled */.zo)("div", {
    display: "none",
    "@bp1": {
        display: "flex"
    }
});

;// CONCATENATED MODULE: ./src/containers/header/index.tsx
















var Search = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8100), __webpack_require__.e(2348), __webpack_require__.e(6110)]).then(__webpack_require__.bind(__webpack_require__, 75981));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75981)
            ];
        }
    },
    ssr: false
});
var Header = function() {
    var ref;
    var t = (0,use_intl_esm3/* default */.Z)("header");
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var auth = (0,es/* useSelector */.v9)(function(state) {
        return state.auth;
    });
    var address = (ref = auth.account) === null || ref === void 0 ? void 0 : ref.address;
    var handleLogin = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var account;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,beacon/* login */.x4)();
                    case 2:
                        account = _ctx.sent;
                        dispatch({
                            type: state_auth/* actions.AUTH_LOGIN */.Nw.AUTH_LOGIN,
                            payload: account
                        });
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowProfile = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch({
                            type: global/* actions.GLOBAL_MOBILE_OFFSET */.Nw.GLOBAL_MOBILE_OFFSET,
                            payload: constants/* MOBILE_OFFSET.LEFT */.AY.LEFT
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShowProfile() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleShowMenu = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch({
                            type: global/* actions.GLOBAL_MOBILE_OFFSET */.Nw.GLOBAL_MOBILE_OFFSET,
                            payload: constants/* MOBILE_OFFSET.RIGHT */.AY.RIGHT
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleShowMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Container */.W2, {
                    css: {
                        width: "100%",
                        height: "$space$1"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Mobile, {
                            css: {
                                position: "relative",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    as: "a",
                                    variant: "basic",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        vertical: true,
                                        children: address ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            variant: "basic",
                                            onClick: handleShowProfile,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfile, {})
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            variant: "secondary",
                                            onClick: handleLogin,
                                            children: t("login")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    locale: router.locale,
                                    prefetch: false,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        as: "a",
                                        "aria-label": "Go to Homepage",
                                        css: {
                                            position: "absolute",
                                            left: "50%",
                                            transform: "translateX(-50%)"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Logo */.TR, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                    as: "a",
                                    variant: "basic",
                                    onClick: handleShowMenu,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                        vertical: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            children: "menu"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Desktop, {
                            css: {
                                position: "relative",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                    vertical: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        locale: router.locale,
                                        prefetch: false,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            "aria-label": "Go to Homepage",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Logo */.TR, {})
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                                    css: {
                                        flex: "auto",
                                        paddingLeft: "$space$3"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Auth, {
                                    children: [
                                        address && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/mint",
                                            locale: router.locale,
                                            prefetch: false,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                as: "a",
                                                variant: "basic",
                                                children: t("mint")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/boards",
                                            locale: router.locale,
                                            prefetch: false,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                as: "a",
                                                variant: "basic",
                                                children: t("boards")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/collections",
                                            locale: router.locale,
                                            prefetch: false,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                as: "a",
                                                variant: "basic",
                                                children: t("collections")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/explore",
                                            locale: router.locale,
                                            prefetch: false,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                                as: "a",
                                                variant: "basic",
                                                children: t("explore")
                                            })
                                        }),
                                        address ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsMenu, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(UserMenu, {})
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Button */.zx, {
                                            variant: "secondary",
                                            onClick: handleLogin,
                                            children: t("login")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Container */.W2, {
                    css: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Box */.xu, {
                        css: {
                            height: 64
                        },
                        vertical: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Search, {
                            isMobile: true
                        })
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 80125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fk": function() { return /* binding */ getURLFromIPFSorHTTP; },
/* harmony export */   "NB": function() { return /* binding */ Node; },
/* harmony export */   "vR": function() { return /* binding */ getURLFromIPFSURI; }
/* harmony export */ });
/* unused harmony export ensureCIDv1 */
/* harmony import */ var multiformats_cid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81362);
/* eslint-disable no-console */ 
var Node;
(function(Node) {
    Node[Node["INFURA"] = 0] = "INFURA";
    Node[Node["CLOUDFLARE"] = 1] = "CLOUDFLARE";
    Node[Node["PINATA"] = 2] = "PINATA";
    Node[Node["IPFS"] = 3] = "IPFS";
    Node[Node["DWEB"] = 4] = "DWEB";
    Node[Node["VERSUM"] = 5] = "VERSUM";
})(Node || (Node = {}));
var ensureCIDv1 = function(cid) {
    if (cid === "") {
        console.warn("empty cid -----<");
        return "";
    }
    if (!cid.startsWith("baf")) {
        cid = multiformats_cid__WEBPACK_IMPORTED_MODULE_0__/* .CID.parse */ .k.parse(cid).toV1().toString();
    }
    return cid;
};
var getURLFromIPFSURI = function(uri) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.IPFS;
    var parts = uri.replace("ipfs://", "").split("/");
    var cid = parts[0];
    var cidv1 = ensureCIDv1(cid);
    var path = parts.length ? "/".concat(parts.slice(1).join("/")) : "";
    switch(type){
        case Node.CLOUDFLARE:
            return "https://cloudflare-ipfs.com/ipfs/".concat(cidv1).concat(path);
        case Node.INFURA:
            return "https://".concat(cidv1, ".ipfs.infura-ipfs.io").concat(path);
        case Node.PINATA:
            return "https://gateway.pinata.cloud/ipfs/".concat(cidv1).concat(path);
        case Node.IPFS:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
        case Node.DWEB:
            return "https://".concat(cidv1, ".ipfs.dweb.link").concat(path);
        case Node.VERSUM:
            return "https://ipfs.versum.cloud/ipfs/".concat(cidv1).concat(path);
        default:
            return "https://ipfs.io/ipfs/".concat(cidv1).concat(path);
    }
};
// converts ipfs:// if match or returns https://
var getURLFromIPFSorHTTP = function() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", node = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Node.INFURA;
    if (value && value.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(value, node);
    }
    return value;
};


/***/ }),

/***/ 49503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ testNodeHealth; }
/* harmony export */ });
/* unused harmony export testNodes */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42660);
/* harmony import */ var _lib_beacon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91435);
/* harmony import */ var _state_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92089);
/* harmony import */ var _state_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80683);


/* eslint-disable @typescript-eslint/no-explicit-any */ 



var testNodes = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var before, result, ref, timestamp, nodes;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    before = Date.now();
                    _ctx.next = 3;
                    return fetch("https://status.versum.xyz/api/rpc");
                case 3:
                    result = _ctx.sent;
                    if (!(result.status === 200)) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.next = 7;
                    return result.json();
                case 7:
                    ref = _ctx.sent;
                    timestamp = ref.timestamp;
                    nodes = ref.nodes;
                    return _ctx.abrupt("return", {
                        response: Date.now() - before,
                        timestamp: timestamp,
                        nodes: nodes
                    });
                case 11:
                    return _ctx.abrupt("return", {
                        response: Date.now() - before,
                        timestamp: Date.now(),
                        nodes: []
                    });
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function testNodes() {
        return _ref.apply(this, arguments);
    };
}();
var testNodeHealth = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var callback, store, state, ping, currentNode, curTry, maxTry, swapAndTestNode, healthyNode, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    callback = _args.length > 0 && _args[0] !== void 0 ? _args[0] : function() {
                        return null;
                    };
                    store = (0,_state_store__WEBPACK_IMPORTED_MODULE_4__/* .getStore */ .bh)();
                    state = store === null || store === void 0 ? void 0 : store.getState();
                    if (!(state.settings.general.nodetype === _constants__WEBPACK_IMPORTED_MODULE_1__/* .NODE_TYPE.AUTO */ .QZ.AUTO)) {
                        _ctx.next = 13;
                        break;
                    }
                    _ctx.next = 6;
                    return testNodes();
                case 6:
                    ping = _ctx.sent;
                    currentNode = ping.nodes.find(function(e) {
                        return "https://".concat(e.node) === state.settings.general.node;
                    });
                    curTry = 0;
                    maxTry = 10;
                    swapAndTestNode = function() {
                        // change to new node
                        (0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .setInitialRandomNode */ .k9)();
                        var nextNode = (0,_constants__WEBPACK_IMPORTED_MODULE_1__/* .getInitialRandomNode */ .hm)().value;
                        // check node from request
                        currentNode = ping.nodes.find(function(e) {
                            return "https://".concat(e.node) === nextNode;
                        });
                        if ((!currentNode || currentNode.level < 0 || currentNode.level > 2) && curTry < maxTry) {
                            curTry += 1;
                            swapAndTestNode();
                        }
                        // if node is valid, save preferences?
                        store === null || store === void 0 ? void 0 : store.dispatch({
                            type: _state_settings__WEBPACK_IMPORTED_MODULE_3__/* .actions.SETTINGS_CHANGE_NODE */ .Nw.SETTINGS_CHANGE_NODE,
                            payload: "https://".concat(currentNode.node)
                        });
                        (0,_lib_beacon__WEBPACK_IMPORTED_MODULE_2__/* .changeBeacon */ .sW)(state.settings.general.network, "https://".concat(currentNode.node));
                    };
                    healthyNode = currentNode.level >= 0 && currentNode.level <= 2;
                    if (!healthyNode) {
                        swapAndTestNode();
                    }
                case 13:
                    callback();
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function testNodeHealth() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 88080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ timeAgo; }
/* harmony export */ });
/* harmony import */ var javascript_time_ago__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19252);
/* harmony import */ var javascript_time_ago_locale_en_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21795);


javascript_time_ago__WEBPACK_IMPORTED_MODULE_0__/* ["default"].addLocale */ .Z.addLocale(javascript_time_ago_locale_en_json__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
var timeAgo = new javascript_time_ago__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z("en-US");


/***/ }),

/***/ 12857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GG": function() { return /* binding */ getScreenName; },
/* harmony export */   "vW": function() { return /* binding */ getUserName; }
/* harmony export */ });
/* unused harmony export sanitiseProfileImage */
/* harmony import */ var _ipfs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80125);
/* harmony import */ var _wallet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49058);
/* eslint-disable no-console */ 

var sanitiseProfileImage = function() {
    var uri = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (uri && uri.indexOf("ipfs://") !== -1) {
        return getURLFromIPFSURI(uri, Node.INFURA);
    }
    // otherwise its already resolved
    return uri;
};
var getUserName = function(id, name) {
    var userName = name === id ? (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id) : "@".concat(name);
    userName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id); // eventually remove
    return userName;
};
var getScreenName = function(verified, screenName, id, name) {
    // validate empty screen name before
    var parsedScreenName = screenName;
    // if screen name is null we fill it with the address
    if (!screenName) {
        parsedScreenName = (0,_wallet__WEBPACK_IMPORTED_MODULE_1__/* .preview */ .RN)(id);
    }
    return verified ? parsedScreenName : getUserName(id, name);
};


/***/ })

}]);